// Supplier / branch prioritisation on the search page (DEV-50739, SP-001..005).
//
// The "Show first" row lists one pill per supplier+branch present in the
// basket. Which pills are TICKED is remembered in localStorage so an engineer
// who comes back tomorrow (basket is server-side, so it is still there) keeps
// the branch they prioritised. The stored list is always re-checked against
// the live basket before use, so a tick can never outlive its basket branch.

// Prefix for the per-tenant, per-user localStorage key. Scoping by both keeps
// a shared device from leaking one engineer's ticks to another.
export const BRANCH_PRIORITY_STORAGE_PREFIX = 'engineer_branch_priority'

// Pills rendered inline before the row collapses the rest behind "+N more".
export const BRANCH_PRIORITY_MAX_VISIBLE_PILLS = 2

// Separator inside a pill key: `${supplierId}${SEP}${branchId}`.
export const BRANCH_PRIORITY_KEY_SEPARATOR = ':'

// Most branch ids the eligibility endpoint accepts in one request. Must match
// BRANCH_PRIORITY_ELIGIBILITY_MAX_IDS in the backend's catalog views: above
// it the endpoint refuses the whole list.
export const BRANCH_PRIORITY_ELIGIBILITY_MAX_IDS = 50
